import { AxiosResponse } from 'axios';
import { HttpMethod } from '../utils/enums/http-method.enum';
import { ITitleInquiryPayload } from './models/title-request.service';
import { RequestClientInterfaceService } from './request-client.interface.service';
import { COGNITO_TOKEN_NAME, DEALER_PORTAL_URL } from '../config';

export class TitleRequestService {
    private readonly dealerPortalUrlStructure = `${DEALER_PORTAL_URL}`;
    private client: RequestClientInterfaceService;

    constructor() {
        this.client = new RequestClientInterfaceService();
    }

    public async submitTitleInquiry(
        payload: ITitleInquiryPayload,
        file?: File | null,
    ): Promise<AxiosResponse> {
        const url = `${this.dealerPortalUrlStructure}/titleInquiry`;
        const cognitoToken = window.sessionStorage.getItem(COGNITO_TOKEN_NAME);

        const formData = new FormData();

        formData.append('vin', payload.vin);
        formData.append('dealerCode', payload.dealerCode);
        formData.append('taskId', payload.taskId);
        formData.append('requestorEmail', payload.requestorEmail);
        formData.append('requestorName', payload.requestorName);
        formData.append('jwtToken', payload.jwtToken);
        formData.append('correlationId', payload.correlationId);

        if (payload.accountType) {
            formData.append('accountType', payload.accountType);
        }
        if (payload.titleMailingAddress) {
            formData.append('titleMailingAddress', payload.titleMailingAddress);
        }
        if (payload.purchaseDate) {
            formData.append('purchaseDate', payload.purchaseDate);
        }
        if (payload.customerName) {
            formData.append('customerName', payload.customerName);
        }
        if (payload.accountNumber) {
            formData.append('accountNumber', payload.accountNumber);
        }
        if (payload.odoMileage != null) {
            formData.append('odoMileage', String(payload.odoMileage));
        }
        if (payload.odometerDate) {
            formData.append('odometerDate', payload.odometerDate);
        }
        if (payload.specialInstructions) {
            formData.append('specialInstructions', payload.specialInstructions);
        }
        if (file) {
            formData.append('file', file, file.name);
        }

        const request = {
            method: HttpMethod.post,
            url,
            headers: {
                Authorization: `Bearer ${cognitoToken}`,
            },
            data: formData,
        };
        return this.client.sendRequest(request);
    }
}
